import {
  ConfirmationDialog,
  ConfirmationDialogIcon,
  ConfirmDialogActions,
} from "../shared-components/ConfirmationDialog";
import { ButtonColorTypes } from "../shared-components/Button";

export const WORKBENCH_CLAIM_PROMPT_TITLE = "Claim Report?";

export const WORKBENCH_CLAIM_PROMPT_MESSAGE =
  "This report is currently unassigned. Would you like to claim it?";

type WorkbenchClaimPromptDialogProps = {
  isOpen: boolean;
  isClaiming: boolean;
  onAction: (action: ConfirmDialogActions) => void;
};

export function WorkbenchClaimPromptDialog({
  isOpen,
  isClaiming,
  onAction,
}: WorkbenchClaimPromptDialogProps) {
  return (
    <ConfirmationDialog
      isOpen={isOpen}
      title={WORKBENCH_CLAIM_PROMPT_TITLE}
      text={WORKBENCH_CLAIM_PROMPT_MESSAGE}
      actionHandler={onAction}
      showActionButtons
      hideCloseButton
      cancelButtonText="No"
      cancelButtonColorType={ButtonColorTypes.cancel}
      confirmButtonText="Yes, Claim"
      confirmButtonColorType={ButtonColorTypes.warning}
      confirmDisabled={isClaiming}
      isConfirmLoading={isClaiming}
      icon={ConfirmationDialogIcon.WARN}
    />
  );
}
